import type { FormEvent, MouseEvent } from 'react';
import { isValidEmail, isValidUserId } from '@library/utils';
import { Search } from '@library/components/inputs';
import searchIconURL from '@library/assets/images/Search.png';
import { useState } from 'react';

export interface PaymentsSearchProps {
  handleSearch: (value: string) => void;
  handleSearchChange: (value: string) => void;
}

export const PaymentsSearch = ({
  handleSearch,
  handleSearchChange
}: PaymentsSearchProps) => {
  const [searchValue, setValue] = useState('');
  const [hasError, setHasError] = useState(false);

  const handleValueChange = (value: string) => {
    if (searchValue.length > value.length) {
      setHasError(false);
    }
    setValue(value);
    handleSearchChange(value);
  };

  const handleSubmit = (
    e: FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    const validEmail = isValidEmail(searchValue);
    const validUserId = isValidUserId(searchValue);
    if (validEmail || validUserId) {
      setHasError(false);
      handleSearch(searchValue);
    } else {
      setHasError(true);
    }
  };

  return (
    <form className="col-span-12 max-w-screen-md" onSubmit={handleSubmit}>
      {hasError && <div className="text-red-500">Invalid User ID or Email</div>}
      <div className="bg-soFresh-110 border-soFresh-140 flex h-11 w-full min-w-min rounded-md border py-1.5 sm:text-sm sm:leading-6">
        <div className="pointer-events-none inset-y-0 left-0 flex items-center pl-3">
          <img src={searchIconURL} alt="search" />
        </div>
        <Search
          className="text-soClean-140 placeholder:text-soClean-140 w-full rounded-md border-0 bg-transparent py-1.5 hover:ring-0 focus:ring-0 sm:text-sm sm:leading-6"
          id="projection-search"
          onValueChange={handleValueChange}
          placeholder="User ID or Email"
          value={searchValue}
        />
      </div>
    </form>
  );
};
